import type { CSSProperties } from 'react'

import { cssColors } from 'shared/ui/utils/cssTokens'

import styles from './LoadingIndicator.module.scss'

export interface LoadingIndicatorProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

const LoadingIndicator = ({
  size = 24,
  color = cssColors.brand.secondary
}: LoadingIndicatorProps) => {
  return (
    <span
      className={styles.root}
      style={
        {
          '--loading-size': `${size}px`,
          '--loading-color': color
        } as CSSProperties
      }
      role='status'
      aria-label='Ładowanie...'
    >
      <svg viewBox='22 22 44 44' aria-hidden>
        <circle cx='44' cy='44' r='20.2' fill='none' strokeWidth={3.6} />
      </svg>
    </span>
  )
}

export default LoadingIndicator
